// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2wHJN","messages":"Chat_messages__1x2yb","dateDivider":"Chat_dateDivider__m2q3_"};